// Early ("pre-flight") check at the end of the Trial Balance step (28 Oct 2026).
//
// Every integrity check used to surface only on the Statements screen or when Generate was refused — after the
// preparer had set up documents, written notes and reviewed. Problems that are properties of the TRIAL BALANCE itself
// (it does not roll forward, the period predates the company, a tax expense mapped as an asset...) can be shown the
// moment the trial balance is mapped. This only selects and words what /api/afs/validate already returns for them;
// it adds no checks of its own, so it cannot disagree with the later gate.
export const PREFLIGHT_CHECK_IDS = new Set([
  'balance_sheet', 'retained_earnings', 'retained_earnings_equals_profit', 'mapping_statement_conflict',
  'tax_expense_as_asset', 'loans_from_entities', 'period_vs_incorporation', 'no_revenue_reported',
  'ppe_without_depreciation', 'unmapped_accounts',
])

export const preflightIssues = (checks) =>
  (Array.isArray(checks) ? checks : [])
    .filter(c => c && PREFLIGHT_CHECK_IDS.has(c.id) && (c.status === 'fail' || c.status === 'warning'))
    .sort((a, b) => (a.status === 'fail' ? 0 : 1) - (b.status === 'fail' ? 0 : 1))

export const preflightMessage = (issues, max = 5) => {
  const shown = issues.slice(0, max).map(i => `• ${i.status === 'fail' ? 'MUST FIX' : 'Check'}: ${i.label || i.id} — ${i.detail}`)
  const more = issues.length > max ? `\n…and ${issues.length - max} more.` : ''
  const hasFail = issues.some(i => i.status === 'fail')
  return (
    `Before you continue, KaiLux found ${issues.length === 1 ? 'something' : issues.length + ' things'} in this trial balance:\n\n` +
    shown.join('\n\n') + more + '\n\n' +
    (hasFail
      ? 'Items marked MUST FIX will stop the final AFS from being generated until they are resolved. '
      : 'These will be raised again before the AFS is generated. ') +
    'Continue anyway? (Cancel to stay and fix them now.)'
  )
}
